module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-71f3f0fc!./packages/dof-swipe-action/colmo.css
// module id = 505
// module chunks = 0 1